<script setup lang="ts">
import type { CmsElementBioCircle } from "~/composables/useCustom";
import SharedHeadline from "~/components/shared/SharedHeadline.vue";
import SharedTopline from "~/components/shared/SharedTopline.vue";

const props = defineProps<{
  content: CmsElementBioCircle;
}>();

const { headlineText, headlineType, toplineText, toplineType, mainText, rightImage, button } = props.content.data

</script>
<template>
  <section class="relative">
    <div class="container max-w-[90rem] laptop:px-10">
      <article class="bg-skin-white md:px-4 rounded pt-20 md:pt-0">
        <div class="container">
          <div class="flex flex-wrap items-center gap-y-11">
            <div class="w-full md:w-2/4 prose-p:text-skin-secondary">
              <SharedTopline :headline="toplineText" :headlineType="toplineType"></SharedTopline>
              <SharedHeadline :headline="headlineText" :headlineType="headlineType"></SharedHeadline>
              <div class="mb-4" v-html="mainText"></div>
              <SharedButton v-if="button" :button="button" btn-type="btn"></SharedButton>
            </div>
            <div class="w-full md:w-2/4 flex justify-center mt-10 md:mt-0">
              <NuxtImg format="webp" loading="lazy" v-if="rightImage && rightImage.media" :src="rightImage.media.url" alt="" class="-mt-8" />
            </div>
          </div>
        </div>
      </article>
    </div>
    <img src="/images/layer3.svg" alt="" class="absolute left-[10%] -top-[20%] hidden lg:block rotate-[120deg]">
  </section>
</template>
